/* RepairFirst Anfrage-Funnel — Overlay-Wizard -> /cart/add.js
 * Ersetzt Globo. Sammelt Felder als Line-Item-Properties, Dateien Shopify-nativ.
 */
(function () {
  'use strict';

  // === CONFIG ===
  // Varianten-ID des 10€-Produkts "UPS-Abholung". MUSS gesetzt werden, sobald das Produkt existiert.
  var UPS_VARIANT_ID = 55492340842878; // "Versandmethode" → Variante "Teil Abholen lassen" (UPS-Abholung, +10€)
  // "Versandmethode" → Variante "Normalversand" (Rückversand, +10€). Wird bei DIREKTKAUF
  // (Festpreis-Variante) als bepreiste Position ergänzt, wenn der Kunde Rückweg=Normalversand
  // wählt; bei "Auf Anfrage" bleibt der Rückweg reine Property (Angebots-Landingpage bepreist).
  // Live verifiziert 2026-07-23: Produkt UNLISTED+published, Variante availableForSale, Policy CONTINUE.
  var RUECKVERSAND_VARIANT_ID = 55874775843198;
  var TOTAL_STEPS = 5;

  var overlay = document.getElementById('rf-funnel');
  if (!overlay) return;
  var RF_MK61_BASE_PRICED = overlay.dataset.rfMk61Priced === '1';
  var RF_MK20_PRICED = overlay.dataset.rfMk20Priced === '1';
  var RF_MK61_PRICED = RF_MK61_BASE_PRICED;
  var mk61Submitting = false;
  var mk61ChoiceMade = false;
  // Self-Gate: Die Handler unten hängen delegiert am document — würde das Snippet auf einer Seite
  // zweimal gerendert, feuerte jeder Klick doppelt (zwei selectVariant/open-Aufrufe).
  if (window.__rfAnfrageFunnel) return;
  window.__rfAnfrageFunnel = true;

  // Prüfpauschale — Variante UND Betrag kommen TYP-ABHÄNGIG aus dem Liquid (data-Attribute an der
  // Pauschale-Checkbox), damit die Preisregel EINE Quelle hat: lib/wms/testpauschale-lookup.ts.
  //   Motorsteuergerät/ECU → 95 € (Variante 56968470266238) · alles andere → 60 € (Variante 55744436404606).
  // Wird als SEPARATE, bepreiste Cart-Position ergänzt (Preis kommt aus der Variante, nicht aus einer Property).
  // Fallback (95 €/Motor) nur, falls die data-Attribute fehlen (alter Cache) — Liquid setzt sie immer.
  var pauschEl = overlay.querySelector('[data-rf-pauschale]');
  var PAUSCHALE_VARIANT_ID = (pauschEl && pauschEl.dataset.rfPauschaleVariant)
    ? parseInt(pauschEl.dataset.rfPauschaleVariant, 10) : 56968470266238;
  var PAUSCHALE_AMOUNT = (pauschEl && pauschEl.dataset.rfPauschaleAmount)
    ? parseFloat(pauschEl.dataset.rfPauschaleAmount) : 95;

  var dialog = overlay.querySelector('.rf-funnel-dialog');
  var steps = Array.prototype.slice.call(overlay.querySelectorAll('.rf-step'));
  var railSteps = Array.prototype.slice.call(overlay.querySelectorAll('[data-rail-step]'));
  var stepNumEl = overlay.querySelector('[data-rf-stepnum]');
  var stepTitleEl = overlay.querySelector('[data-rf-steptitle]');
  var backBtn = overlay.querySelector('[data-rf-back]');
  var nextBtn = overlay.querySelector('[data-rf-next]');
  var submitBtn = overlay.querySelector('[data-rf-submit]');
  var submitError = overlay.querySelector('[data-rf-submiterror]');
  var current = 1;
  // A11y (#9a): Element, das vor dem Öffnen des Dialogs den Fokus hatte — close() stellt ihn wieder her
  var lastFocusedBeforeOpen = null;

  // === ABHOLDATUM: keine Vergangenheit ===
  // `min` wird aus dem CLIENT-Datum in Europe/Berlin gesetzt, nicht aus Liquid: Shopify cacht
  // die Produktseite, ein dort gerendertes Datum waere nach dem naechsten Tageswechsel veraltet.
  function todayBerlinISO() {
    try { return new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' }); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  var pickupDateInp = overlay.querySelector('[data-rf-pickupdate]');
  function refreshPickupMin() {
    if (pickupDateInp) pickupDateInp.setAttribute('min', todayBerlinISO());
  }
  refreshPickupMin();

  // === OPEN / CLOSE ===
  function open(step) {
    if ((RF_MK61_PRICED || RF_MK20_PRICED) && !mk61ChoiceMade) { var first = document.querySelector('[data-rf-variant]'); if (first) { first.focus(); first.scrollIntoView({behavior:'smooth',block:'center'}); } return; }
    refreshPickupMin();  // Tab kann ueber Mitternacht offen gestanden haben
    applyFehlerTexts();  // Fehlercodes-Label/-Hinweis zur (ggf. wiederhergestellten) Auswahl
    // Varianten- und Länderregeln bei jedem Öffnen anwenden — deckt den [data-rf-open]-Pfad
    // ohne Cards ab und hält den Zustand nach Resume/Restore konsistent.
    reflectVariant(selectedVariantTitle, selectedVariantPrice);
    applyVariantRules();
    applyCountryRules();
    overlay.classList.add('is-open');
    refreshCartGuard(); // belegter Warenkorb -> Hinweis-Panel statt Formular (async)
    rfTrack('repair_funnel_opened', { entry: rfEntry, step: step || current });
    rfEntry = 'resume';
    document.body.classList.add('rf-funnel-locked');
    // A11y (#9a): Auslöser merken und Fokus in den Dialog setzen — der Schließen-Button ist
    // das erste fokussierbare Element; close() gibt den Fokus an den Auslöser zurück.
    lastFocusedBeforeOpen = document.activeElement;
    var closeBtn = overlay.querySelector('.rf-funnel-close');
    if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
    goTo(step || current); // ohne Argument: Resume an der zuletzt aktiven Stelle (nach Reload/Schließen)
  }
  function close() {
    if (!rfSubmitting && overlay.classList.contains('is-open')) {
      rfTrack('repair_funnel_closed', { step: current, guard_active: overlay.classList.contains('rf-guard-active') });
    }
    overlay.classList.remove('is-open');
    document.body.classList.remove('rf-funnel-locked');
    // A11y (#9a): Fokus zum Element zurückgeben, das vor dem Öffnen fokussiert war
    if (lastFocusedBeforeOpen && typeof lastFocusedBeforeOpen.focus === 'function') {
      try { lastFocusedBeforeOpen.focus(); } catch (e) {}
    }
    lastFocusedBeforeOpen = null;
  }
  // Öffner per Event-Delegation statt Direktbindung: Der CTA-Button liegt im Block-Order NACH
  // diesem Snippet (product.product-variants) — beim Script-Load existiert er noch nicht.
  // Delegation greift außerdem, wenn das Theme Sections nachrendert.
  function closestSel(el, sel) { return (el && el.closest) ? el.closest(sel) : null; }
  document.addEventListener('click', function (e) {
    var t = closestSel(e.target, '[data-rf-open]');
    if (!t) return;
    e.preventDefault();
    rfEntry = 'button';
    open();
  });
  overlay.querySelectorAll('[data-rf-close]').forEach(function (b) { b.addEventListener('click', close); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });

  // === A11y-FOKUSFALLE (#9a) ===
  // Tab/Shift+Tab bleiben im Dialog: alle sichtbaren fokussierbaren Elemente sammeln und
  // erstes/letztes zyklisch verbinden. Elemente in .rf-hidden-Containern und inaktiven Steps
  // fallen über getClientRects() raus (beides display:none). Nicht gecheckte Radios einer
  // Gruppe MIT Auswahl werden übersprungen — nativ ist nur das gecheckte Radio der Tab-Stopp
  // der Gruppe (Pfeiltasten wechseln innerhalb); ohne Auswahl bleiben alle Radios Kandidaten.
  function getDialogFocusables() {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(dialog.querySelectorAll(sel)).filter(function (el) {
      if (!el.getClientRects().length) return false; // display:none (.rf-hidden, inaktiver Step)
      if (el.type === 'radio' && !el.checked && dialog.querySelector('input[name="' + el.name + '"]:checked')) return false;
      return true;
    });
  }
  dialog.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusables = getDialogFocusables();
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first || !dialog.contains(document.activeElement)) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last || !dialog.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  // === VARIANT-CARDS: Klick wählt die Reparaturart UND öffnet den Funnel (BB-Pattern: kein separater ATC-Button) ===
  // Startwerte aus dem Liquid. Auf Templates MIT Cards ueberschreibt der erste Kartenklick sie;
  // auf product.json (Einstieg ueber [data-rf-open]) bleiben sie die einzige Quelle.
  var _initCents = overlay.dataset.initialCents;
  var selectedVariantId = overlay.dataset.initialVariant || null;
  var selectedVariantTitle = overlay.dataset.initialLabel || null;
  var selectedVariantPrice = overlay.dataset.initialPrice || null;
  var selectedVariantCents = (_initCents != null && _initCents !== '') ? parseInt(_initCents, 10) : null;
  // Roh-Titel der Shopify-Variante (nicht das UI-Label) — Basis für die Varianten-Regeln unten
  var selectedVariantRawTitle = overlay.dataset.initialRawtitle || null;
  var variantTagEl = overlay.querySelector('[data-rf-varianttag]');

  // === POSTHOG-TRACKING (2026-07-30) ===
  // Andockt ans Theme-PostHog (theme.liquid). Immer no-op-sicher: Tracking darf das
  // Popup nie brechen (Adblocker, Consent, PostHog nicht geladen). Gemeinsame Props
  // pro Event, damit spätere Funnels ohne Joins auskommen. form:'rf-popup-v1'
  // unterscheidet den neuen Funnel vom abgelösten Globo-Formular in Vergleichen.
  function rfTrack(name, props, opts) {
    try {
      if (!window.posthog || typeof posthog.capture !== 'function') return;
      var base = {
        form: 'rf-popup-v1',
        product_id: overlay.dataset.rfKey || null,
        product_title: overlay.dataset.productTitle || null,
        variant_title: selectedVariantRawTitle || null,
        variant_cents: selectedVariantCents,
        country: RF_COUNTRY,
        non_eu: RF_NON_EU
      };
      for (var k in (props || {})) base[k] = props[k];
      posthog.capture(name, base, opts);
    } catch (e) { /* Tracking nie fatal */ }
  }
  var rfEntry = 'resume';       // wird von den Click-Handlern vor open() gesetzt
  var rfSubmitting = false;     // unterdrückt das closed-Event beim Checkout-Redirect

  // === GEO-GATE (Shopify Markets, 2026-07-30) ===
  // DE/EU: Rückweg wird im Popup gefragt und als 10-€-Flat-Item bepreist (Tims Entscheid).
  // Nicht-EU (v.a. Schweiz): Frage + Item entfallen — die Kasse berechnet die echte
  // Nicht-EU-Zonen-Rate (die am Go-Live bewusst NICHT neutralisiert wird). Die UPS-Abholung
  // wird mit ausgeblendet (reale Auslands-Abholkosten liegen weit über 10 €).
  // Ohne Country-Kontext (leeres Attribut): DE-Verhalten — kein Regressionsrisiko.
  var RF_EU_COUNTRIES = ['DE','AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var RF_COUNTRY = ((overlay.dataset.rfCountry || '').trim().toUpperCase()) || 'DE';
  var RF_NON_EU = RF_EU_COUNTRIES.indexOf(RF_COUNTRY) < 0;
  function applyCountryRules() {
    if (!RF_NON_EU) return;
    var head = overlay.querySelector('[data-rf-rueckweg-head]');
    var block = overlay.querySelector('[data-rf-rueckweg-block]');
    var hint = overlay.querySelector('[data-rf-ausland-hint]');
    if (head) head.classList.add('rf-hidden');
    if (block) {
      block.classList.add('rf-hidden'); // validateStep überspringt Pflichtgruppen in .rf-hidden
      block.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
    }
    if (hint) hint.classList.remove('rf-hidden');
    // UPS-Abholung (Hinweg) für Nicht-EU ausblenden — Selbstversand bleibt wählbar
    var upsRadio = overlay.querySelector('[name="rf_hinweg"][data-rf-ups]');
    if (upsRadio) {
      upsRadio.checked = false;
      upsRadio.classList.add('rf-hidden');
      var upsLbl = overlay.querySelector('label[for="' + upsRadio.id + '"]');
      if (upsLbl) upsLbl.classList.add('rf-hidden');
    }
    // Termin-Block explizit mit verstecken: im Restore-Fall (UPS war gewählt) hat
    // applyVariantRules() ihn in open() bereits eingeblendet, BEVOR wir das Radio entchecken —
    // sonst bliebe ein sichtbares Pflicht-Abholdatum ohne wählbare UPS-Option stehen.
    var upsTermin = overlay.querySelector('[data-rf-block="ups"]');
    if (upsTermin) upsTermin.classList.add('rf-hidden');
  }
  applyCountryRules();

  // === VARIANTEN-REGELN (aus Globo OptionsExport übernommen + Abhol-Entkopplung 2026-07-21) ===
  // 1) Prüfpauschale HIDE bei 'Auf Anfrage' / 'Überprüfung auf Fehler' / 'Update/Freischaltung' (checkbox-2-Regel)
  // 2) "Auf Anfrage"-Variante bekommt den Kostenlos-&-unverbindlich-Text statt des Standard-Trust-Texts (paragraph-5)
  // 3) "Auf Anfrage": Hinweg = nur unverbindliche Präferenz — kein 10-€-UPS-Add-on, kein Abholdatum/
  //    Zeitfenster; die verbindliche Buchung macht die Angebots-Landingpage (/angebot/[token], performBooking)
  function isAufAnfrageVariant() {
    var t = (selectedVariantRawTitle || '').toLowerCase();
    return t.indexOf('auf anfrage') > -1 || selectedVariantCents === 0;
  }
  // "Ueberpruefung auf Fehler" = bezahlte Diagnose mit anschliessendem Kostenvoranschlag.
  // Eigener Trust-Text, weil weder "kostenlos" (Auf Anfrage) noch "Festpreis" zutrifft.
  function isDiagnoseVariant() {
    var t = (selectedVariantRawTitle || '').toLowerCase();
    return t.indexOf('überprüfung') > -1 || t.indexOf('uberprufung') > -1 ||
           t.indexOf('prüfung') > -1 || t.indexOf('pruefung') > -1;
  }
  // CTA-Text folgt der Variante: bei "Auf Anfrage" führt der Weg zwar technisch durch
  // den (kostenlosen) Checkout, aber "Weiter zur Kasse" widerspräche der
  // "Kostenlos und unverbindlich"-Trust-Box direkt darüber (Daniel, 30.07.).
  function rfSubmitLabel() {
    return isAufAnfrageVariant() ? 'Kostenlos anfragen' : 'Weiter zur Kasse';
  }
  function variantHidesPauschale() {
    var t = (selectedVariantRawTitle || '').toLowerCase();
    // 0-EUR-Variante = Anfrage, unabhaengig vom Titel. Deckt Ausreisser wie "Standard" zu 0,00 EUR
    // ab, bei denen der Trust-Text Kostenfreiheit versprach, die Pauschale aber Pflicht war.
    if (selectedVariantCents === 0) return true;
    if (!t) return false;
    // 'klon': beim Klonen faellt keine Pruefpauschale an (Tim, 2026-07-30) —
    // bei Generalueberholung dagegen schon (deshalb dort KEIN Eintrag).
    return t.indexOf('auf anfrage') > -1 || t.indexOf('prüfung') > -1 || t.indexOf('pruefung') > -1 ||
           t.indexOf('update') > -1 || t.indexOf('freischaltung') > -1 || t.indexOf('klon') > -1;
  }
  function applyVariantRules() {
    var row = overlay.querySelector('[data-rf-pauschale-row]');
    var pausch = overlay.querySelector('[data-rf-pauschale]');
    var hide = variantHidesPauschale();
    if (row) row.classList.toggle('rf-hidden', hide);
    if (hide && pausch) pausch.checked = false; // versteckt darf nie mit in den Cart
    var trustFestpreis = overlay.querySelector('[data-rf-trust-festpreis]');
    var trustPruefung = overlay.querySelector('[data-rf-trust-pruefung]');
    var trustAnfrage = overlay.querySelector('[data-rf-trust-aufanfrage]');
    var anfrage = isAufAnfrageVariant();
    var mk20Heading = overlay.querySelector('[data-rf-mk20-heading]'); if (mk20Heading) mk20Heading.textContent = 'Reparatur beauftragen';
    // Trust-Text dreiwertig: "Auf Anfrage" schlaegt Diagnose schlaegt Festpreis.
    var diagnose = isDiagnoseVariant();
    if (trustAnfrage)   trustAnfrage.classList.toggle('rf-hidden', !anfrage);
    if (trustPruefung)  trustPruefung.classList.toggle('rf-hidden', anfrage || !diagnose);
    if (trustFestpreis) trustFestpreis.classList.toggle('rf-hidden', anfrage || diagnose);
    // Hinweg-Entkopplung bei "Auf Anfrage": Preiszusatz + Termin-Block aus, Präferenz-Hinweis an.
    // Der Termin-Block hängt zusätzlich am UPS-Radio (siehe rf_hinweg-Change-Handler) — hier
    // dieselbe Logik, damit ein Varianten-Wechsel den Block sofort nachzieht.
    var upsPrice = overlay.querySelector('[data-rf-ups-price]');
    var hinwegHint = overlay.querySelector('[data-rf-hinweg-aufanfrage]');
    var upsBlock = overlay.querySelector('[data-rf-block="ups"]');
    var upsRadio = overlay.querySelector('[name="rf_hinweg"][data-rf-ups]');
    // Preiszusatz am UPS-Radio bleibt IMMER sichtbar (Tim, 2026-07-30): auch bei
    // "Auf Anfrage" soll der Kunde die 10 € früh sehen. Berechnet wird dort weiterhin
    // nichts — der Hinweis darunter erklärt den Zeitpunkt (erst mit dem Angebot).
    if (upsPrice) upsPrice.classList.remove('rf-hidden');
    if (hinwegHint) hinwegHint.classList.toggle('rf-hidden', !anfrage);
    if (upsBlock) upsBlock.classList.toggle('rf-hidden', anfrage || !(upsRadio && upsRadio.checked));
    if (submitBtn && !submitBtn.disabled) submitBtn.textContent = rfSubmitLabel(); // nicht während "Wird hinzugefügt …"
    updateTotal();
  }
  function reflectVariant(title, priceLabel) {
    if (!variantTagEl) return;
    if (title) {
      variantTagEl.innerHTML = 'Reparaturart: <b>' + escapeHtml(title) + '</b>' +
        (priceLabel ? ' · ' + escapeHtml(priceLabel) : '');
      variantTagEl.classList.remove('rf-hidden');
    } else {
      variantTagEl.classList.add('rf-hidden');
    }
  }
  function selectVariant(id, title, priceLabel, cents, rawTitle, doOpen) {
    if ((RF_MK61_BASE_PRICED || RF_MK20_PRICED) && doOpen) mk61ChoiceMade = true;
    selectedVariantId = id;
    selectedVariantTitle = title || null;
    selectedVariantPrice = priceLabel || null;
    selectedVariantCents = (cents != null && cents !== '') ? parseInt(cents, 10) : null;
    selectedVariantRawTitle = rawTitle || title || null;
    if (RF_MK20_PRICED) RF_MK61_PRICED = RF_MK61_BASE_PRICED || Number(selectedVariantCents) > 0;
    reflectVariant(selectedVariantTitle, selectedVariantPrice);
    applyVariantRules();
    saveState();
    if (doOpen) open(); // Resume an zuletzt aktiver Stelle; Formularinhalt bleibt via sessionStorage erhalten
  }
  // Varianten-Cards ebenfalls delegiert (Live-Cards kommen aus rf_variant_cards.liquid und
  // können vom Theme nachgerendert werden). preventDefault, weil die Live-Card ein <a href> ist.
  document.addEventListener('click', function (e) {
    var card = closestSel(e.target, '[data-rf-variant]');
    if (!card || card.disabled || card.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    rfEntry = 'card';
    selectVariant(card.dataset.rfVariant, card.dataset.rfVariantTitle, card.dataset.rfVariantPrice, card.dataset.rfVariantCents, card.dataset.rfVariantRawtitle, true);
    rfTrack('repair_funnel_variant_selected', {});
  });

  // === STEP NAVIGATION ===
  function goTo(n) {
    current = Math.max(1, Math.min(TOTAL_STEPS, n));
    steps.forEach(function (s) { s.classList.toggle('is-active', +s.dataset.step === current); });
    var active = steps[current - 1];
    stepNumEl.textContent = current;
    stepTitleEl.textContent = active ? active.dataset.title : '';
    railSteps.forEach(function (li, i) {
      var idx = i + 1;
      li.classList.toggle('is-done', idx < current);
      li.classList.toggle('is-current', idx === current);
    });
    backBtn.classList.toggle('rf-hidden', current === 1);
    nextBtn.classList.toggle('rf-hidden', current === TOTAL_STEPS);
    submitBtn.classList.toggle('rf-hidden', current !== TOTAL_STEPS);
    submitError.style.display = 'none';
    if (current === TOTAL_STEPS) buildSummary();
    dialog.querySelector('.rf-funnel-body').scrollTop = 0;
    saveState();
  }
  nextBtn.addEventListener('click', function () {
    if (validateStep(current)) { rfTrack('repair_funnel_step_completed', { step: current }); goTo(current + 1); return; }
    rfTrack('repair_funnel_step_blocked', { step: current });
    // BB-Pattern: "Weiter" darf nicht stumm blocken — Hinweis zeigen + zum ersten Fehler scrollen
    submitError.textContent = 'Bitte füllen Sie die markierten Felder aus.';
    submitError.style.display = 'block';
    focusFirstError(current);
  });
  backBtn.addEventListener('click', function () { goTo(current - 1); });

  // === CONDITIONAL LOGIC ===
  // Fahrzeug-Modus: upload vs manuell
  overlay.querySelectorAll('[name="rf_vehicle_mode"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var manual = overlay.querySelector('[data-rf-block="manual"]');
      var upload = overlay.querySelector('[data-rf-block="upload"]');
      var isManual = r.value === 'manual' && r.checked;
      if (r.checked) {
        manual.classList.toggle('rf-hidden', !isManual);
        upload.classList.toggle('rf-hidden', isManual);
      }
    });
  });
  // Kundentyp: geschäftlich -> USt-Block
  overlay.querySelectorAll('[name="rf_kundentyp"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var b = overlay.querySelector('[data-rf-block="geschaeftlich"]');
      if (r.checked) b.classList.toggle('rf-hidden', r.value !== 'geschäftlich');
    });
  });
  // Fehlercodes-Auswahl -> Label + Hinweistext über der Fehlerbeschreibung wechseln
  // (Globo: heading-18/19 + paragraph-1/3/4, in die Sie-Form übertragen)
  // Labels + Hinweistexte WOERTLICH aus dem Globo-Export (kurzfristig/formexport/OptionsExport.csv,
  // HTML-dekodiert) — nicht neu formuliert. Der Hinweis stand dort als rote Box unter dem Feld;
  // im alten Funnel fehlte er faktisch, weil applyFehlerTexts() nie initial lief (s.u.).
  var FEHLER_TEXTS = {
    'Fehlercodes gespeichert': {
      label: 'Fehlercodes inkl. Beschreibung & Beschreibung des Fehlverhaltens im Fahrzeug',
      hint: 'Hinweis: Bitte beschreiben Sie die ausgelesenen Fehlercodes inkl. Beschreibung sowie das Fehlverhalten im Fahrzeug möglichst genau. Je mehr Informationen Sie angeben, desto schneller und gezielter können wir Ihren Auftrag bearbeiten.',
      warn: false
    },
    'Keine Fehlercodes gespeichert': {
      label: 'Allgemeine Fehlerbeschreibung/ Beschreibung des Fehlverhaltens im Fahrzeug',
      hint: 'Hinweis: Bitte beschreiben Sie das Fehlverhalten im Fahrzeug möglichst genau. Je mehr Informationen Sie angeben, desto schneller und gezielter können wir Ihren Auftrag bearbeiten.',
      warn: false
    },
    'Keine Kommunikation mit Steuergerät': {
      label: 'Allgemeine Fehlerbeschreibung/ Beschreibung des Fehlverhaltens im Fahrzeug',
      hint: 'Hinweis: Bitte beschreiben Sie das Fehlverhalten im Fahrzeug möglichst genau. Je mehr Informationen Sie angeben, desto schneller und gezielter können wir Ihren Auftrag bearbeiten.',
      warn: false
    },
    'Keine Fehlercodes ausgelesen': {
      label: 'Allgemeine Fehlerbeschreibung/ Beschreibung des Fehlverhaltens im Fahrzeug',
      hint: 'Hinweis: Diagnose und Reparatur sind ohne Fehlercodes nur eingeschränkt möglich.',
      warn: true
    }
  };
  // Kombiinstrumente & Navis (Kundenwunsch 2026-08-16): Fehlercodes sind dort für die
  // Diagnose nicht entscheidend — die rote "nur eingeschränkt möglich"-Warnung wäre
  // irreführend. Stattdessen derselbe Beschreibungs-Hinweis wie bei "Keine Fehlercodes
  // gespeichert". Flag kommt aus dem Liquid (product.type-Kanon, inkl. 'tacho').
  if (overlay.dataset.rfFehlerMild === '1') {
    FEHLER_TEXTS['Keine Fehlercodes ausgelesen'] = {
      label: 'Allgemeine Fehlerbeschreibung/ Beschreibung des Fehlverhaltens im Fahrzeug',
      hint: 'Hinweis: Bitte beschreiben Sie das Fehlverhalten im Fahrzeug möglichst genau. Je mehr Informationen Sie angeben, desto schneller und gezielter können wir Ihren Auftrag bearbeiten.',
      warn: false
    };
  }
  function applyFehlerTexts() {
    var lbl = overlay.querySelector('[data-rf-fehler-label]');
    var hint = overlay.querySelector('[data-rf-fehler-hint]');
    var sel = overlay.querySelector('[name="rf_fehlercodes"]:checked');
    var t = sel && FEHLER_TEXTS[sel.value];
    if (!lbl || !hint) return;
    var box = overlay.querySelector('[data-rf-hint-confirm]');
    if (t) {
      lbl.textContent = t.label;
      hint.textContent = t.hint;
      if (box) {
        box.classList.remove('rf-hidden');
        box.classList.toggle('rf-hint-warn-on', t.warn);
      }
    } else {
      lbl.textContent = 'Fehlerbeschreibung';
      if (box) box.classList.add('rf-hidden'); // ohne Auswahl kein Hinweis -> nichts zu bestaetigen
    }
  }
  overlay.querySelectorAll('[name="rf_fehlercodes"]').forEach(function (r) {
    r.addEventListener('change', applyFehlerTexts);
  });
  // WICHTIG: einmal initial ausfuehren. restoreState() setzt die Radios programmatisch
  // (el.checked = true) — das feuert KEIN change-Event. Ohne diesen Aufruf blieb nach jedem
  // Reload das Label auf dem Default 'Fehlerbeschreibung' stehen und der Hinweis versteckt.
  applyFehlerTexts();
  // Hinweg: UPS-Abholung -> Abholdatum/Zeitfenster-Block (bei "Auf Anfrage" nie — Termin kommt
  // erst auf der Angebots-Landingpage; die Radio-Wahl bleibt reine Präferenz-Property)
  overlay.querySelectorAll('[name="rf_hinweg"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var upsBlock = overlay.querySelector('[data-rf-block="ups"]');
      var upsRadio = overlay.querySelector('[name="rf_hinweg"][data-rf-ups]');
      if (upsBlock) upsBlock.classList.toggle('rf-hidden', isAufAnfrageVariant() || !(upsRadio && upsRadio.checked));
    });
  });
  // === UPLOAD-GESAMTLIMIT (#6) ===
  // Alle Dateien (Fahrzeugschein + Anhänge) gehen beim Submit in EINEM /cart/add.js-Request.
  // Ab ~20 MB Gesamtgröße antwortet der Server mit einer 413-HTML-Seite — der Kunde sähe nur
  // eine generische Fehlermeldung und käme nie durch. 18 MB lässt Puffer unter der Servergrenze
  // (Multipart-Overhead, Base64-Anteile).
  var RF_MAX_UPLOAD_BYTES = 18 * 1024 * 1024;
  // Summe ALLER gewählten Dateien beider Datei-Inputs im Overlay. Inputs in .rf-hidden-Blöcken
  // zählen nicht mit — deren Dateien werden beim Submit auch nicht gesendet (doSubmit skippt sie).
  function rfTotalUploadBytes() {
    var total = 0;
    overlay.querySelectorAll('input[type="file"]').forEach(function (inp) {
      if (inp.closest('.rf-hidden') || !inp.files) return;
      for (var i = 0; i < inp.files.length; i++) total += inp.files[i].size;
    });
    return total;
  }
  // Prüft das Gesamtlimit und zeigt die Meldung am Feld des übergebenen Inputs (bestehende
  // .rf-error-msg-Mechanik, Text-Swap wie beim Abholdatum; Standardtext wird gemerkt und bei
  // OK wiederhergestellt). Die Dateiauswahl bleibt bewusst ERHALTEN (anders als beim
  // >10-Dateien-Check) — der Kunde soll sehen, welche Auswahl zu groß ist.
  // Rückgabe: true = Limit überschritten (und dieses Feld trägt Dateien bei).
  function rfCheckUploadSize(inp) {
    var field = inp.closest('.rf-field') || inp.closest('[data-rf-block]');
    var msg = field && field.querySelector('.rf-error-msg');
    if (msg && msg.dataset.rfDefaultMsg == null) msg.dataset.rfDefaultMsg = msg.textContent;
    var total = rfTotalUploadBytes();
    if (inp.files && inp.files.length && total > RF_MAX_UPLOAD_BYTES) {
      if (msg) {
        var mb = (total / (1024 * 1024)).toFixed(1).replace('.', ',');
        msg.textContent = 'Ihre Dateien sind zusammen zu groß (' + mb + ' MB, maximal 18 MB). ' +
          'Bitte verkleinern Sie Fotos oder entfernen Sie einzelne Anhänge.';
      }
      setError(field, true);
      rfTrack('repair_funnel_upload_blocked', { total_mb: Math.round(total / 1048576 * 10) / 10 });
      return true;
    }
    if (msg) msg.textContent = msg.dataset.rfDefaultMsg; // Standardtext zurück (z.B. Fahrzeugschein-Pflichthinweis)
    return false;
  }

  // Datei-Name anzeigen (Multi-Inputs: Anzahl; >10 Dateien -> Auswahl verwerfen, Globo-Limit max 10)
  overlay.querySelectorAll('input[type="file"]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var nameEl = inp.parentElement.querySelector('[data-rf-filename]');
      if (inp.multiple && inp.files && inp.files.length > 10) {
        inp.value = '';
        if (nameEl) nameEl.textContent = 'Maximal 10 Dateien — bitte Auswahl reduzieren.';
        return;
      }
      if (nameEl) {
        if (!inp.files || !inp.files.length) nameEl.textContent = '';
        else if (inp.files.length > 1) nameEl.textContent = '✓ ' + inp.files.length + ' Dateien ausgewählt';
        else nameEl.textContent = '✓ ' + inp.files[0].name;
      }
      // Gesamtlimit (#6): bei Überschreitung Fehler am Feld anzeigen, Auswahl aber behalten;
      // sonst wie bisher die Fehlermarkierung des Feldes löschen.
      if (!rfCheckUploadSize(inp)) {
        clearError(inp.closest('[data-rf-block]') || inp.closest('.rf-field'));
      }
    });
  });

  // === VALIDATION ===
  function setError(el, on) { if (el) el.classList.toggle('has-error', !!on); }
  function clearError(el) { setError(el, false); }
  // Pflicht-Checkboxen (Pauschale/AGB/Hinweis): Fehlermarkierung sofort löschen, sobald angehakt —
  // sonst steht der rote Hinweis trotz gesetztem Haken bis zum nächsten Validate (Daniel-Screenshot)
  overlay.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-req-check]') && t.checked) clearError(t.closest('.rf-field'));
  });

  function validateStep(n) {
    var step = steps[n - 1];
    if (!step) return true; // Schritt existiert nicht (z.B. veralteter Index) → nichts zu validieren
    var ok = true;
    // Pflicht-Textfelder im aktiven (sichtbaren) Bereich
    step.querySelectorAll('[data-req]').forEach(function (inp) {
      var hiddenBlock = inp.closest('.rf-hidden');
      var field = inp.closest('.rf-field') || inp.closest('[data-rf-block]');
      if (hiddenBlock) { clearError(field); return; }
      var v = inp.value.trim();
      // data-req-len: exakte Länge (Globo min/max, z.B. FIN 17/17)
      var reqLen = parseInt(inp.dataset.reqLen || '0', 10);
      if (!v || (reqLen && v.length !== reqLen)) { setError(field, true); ok = false; } else clearError(field);
    });
    // Längen-Check für OPTIONALE Felder mit data-req-len (z.B. FIN außerhalb Motor):
    // leer ist ok, aber wer etwas einträgt, muss die volle Länge liefern.
    step.querySelectorAll('[data-req-len]:not([data-req])').forEach(function (inp) {
      var field = inp.closest('.rf-field') || inp.closest('[data-rf-block]');
      if (inp.closest('.rf-hidden')) { clearError(field); return; }
      var v = inp.value.trim();
      var reqLen = parseInt(inp.dataset.reqLen || '0', 10);
      if (v && reqLen && v.length !== reqLen) { setError(field, true); ok = false; } else clearError(field);
    });
    // Pflicht-Checkbox (versteckte/conditional überspringen)
    step.querySelectorAll('[data-req-check]').forEach(function (cb) {
      var field = cb.closest('.rf-field');
      if (cb.closest('.rf-hidden')) { clearError(field); return; }
      if (!cb.checked) { setError(field, true); ok = false; } else clearError(field);
    });
    // Pflicht-Radiogruppen (versteckte/conditional überspringen)
    step.querySelectorAll('[data-rf-reqgroup]').forEach(function (group) {
      var field = group.closest('.rf-field');
      if (group.closest('.rf-hidden')) { clearError(field); return; }
      var name = group.dataset.rfReqgroup;
      var checked = overlay.querySelector('[name="' + name + '"]:checked');
      if (!checked) { setError(field, true); ok = false; } else clearError(field);
    });
    // Schritt 1 Sonderfall: Upload-Modus -> Datei Pflicht
    if (n === 1) {
      var mode = overlay.querySelector('[name="rf_vehicle_mode"]:checked');
      if (mode && mode.value === 'upload') {
        var fileInp = overlay.querySelector('[data-rf-block="upload"] input[type="file"]');
        var ub = overlay.querySelector('[data-rf-block="upload"]');
        if (!fileInp.files || !fileInp.files.length) { setError(ub, true); ok = false; } else clearError(ub);
      }
    }
    // Gesamtlimit-Check (#6) für die Schritte mit Datei-Inputs (1: Fahrzeugschein, 2: Anhänge) —
    // blockt auch den Submit-Weg (der alle Schritte validiert). Geprüft wird die SUMME beider
    // Inputs; markiert wird nur ein Feld, das selbst Dateien beiträgt. Bei OK wird eine ggf.
    // veraltete Größen-Markierung gelöscht (nur wenn Dateien gewählt sind, damit der
    // Pflicht-Fehler "Fahrzeugschein fehlt" von oben nicht überschrieben wird).
    if (n === 1 || n === 2) {
      step.querySelectorAll('input[type="file"]').forEach(function (fi) {
        if (fi.closest('.rf-hidden')) return;
        if (rfCheckUploadSize(fi)) { ok = false; }
        else if (fi.files && fi.files.length) { clearError(fi.closest('.rf-field') || fi.closest('[data-rf-block]')); }
      });
    }
    // Schritt 4 Sonderfall: Abholdatum nicht in der Vergangenheit. `min` allein reicht nicht —
    // der Funnel nutzt keine native Formularvalidierung, und Tastatureingabe umgeht den Picker.
    if (n === 4 && pickupDateInp && !pickupDateInp.closest('.rf-hidden')) {
      var pdField = pickupDateInp.closest('.rf-field');
      var pdMsg = pdField && pdField.querySelector('.rf-error-msg');
      if (pickupDateInp.value && pickupDateInp.value < todayBerlinISO()) {
        if (pdMsg) pdMsg.textContent = 'Das Abholdatum liegt in der Vergangenheit — bitte wählen Sie einen Termin ab heute.';
        setError(pdField, true); ok = false;
      } else if (pdMsg && pickupDateInp.value) {
        pdMsg.textContent = 'Bitte Abholdatum wählen.';
      }
    }
    return ok;
  }

  // Scrollt zum ersten fehlerhaften Feld im Schritt und fokussiert es (sonst blockt "Weiter" unsichtbar unter dem Fold)
  function focusFirstError(n) {
    var step = steps[n - 1];
    if (!step) return;
    var errField = step.querySelector('.rf-field.has-error, [data-rf-block].has-error');
    if (!errField) return;
    errField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var inp = errField.querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="file"]), textarea, select');
    if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
  }

  // === SUMMARY ===
  function collectFields() {
    var data = {};
    overlay.querySelectorAll('[data-prop]').forEach(function (el) {
      var key = el.dataset.prop;
      // Felder in ausgeblendeten Conditional-Blöcken NIE mitnehmen (z.B. Zeitraum nach
      // Wechsel UPS→Selbstversand, Fahrzeugschein nach Wechsel Upload→manuell).
      // Ausnahme type="hidden" (Teilekategorie): liegt bewusst außerhalb aller .rf-hidden-Blöcke.
      if (el.closest('.rf-hidden')) return;
      if (el.type === 'radio') { if (el.checked) data[key] = el.value; }
      else if (el.type === 'checkbox') { if (el.checked) data[key] = el.value; }
      else if (el.type === 'file') {
        if (el.files && el.files.length) data[key] = el.files.length > 1 ? el.files.length + ' Dateien' : el.files[0].name;
      }
      else if (el.value && el.value.trim()) data[key] = el.value.trim();
    });
    return data;
  }
  function buildSummary() {
    var d = collectFields();
    var groups = [
      { t: 'Fahrzeug', step: 1, keys: ['Fahrzeugschein', 'Marke', 'Modell', 'Serie', 'FIN', 'Datum der Erstzulassung', 'Antrieb', 'Getriebe'] },
      { t: 'Teilenummer & Fehler', step: 2, keys: ['Teilenummer(n)', 'Fehlercodes ausgelesen?', 'Allgemeine Fehlerbeschreibung', 'Anhänge', 'Hinweis'] },
      { t: 'Kunde', step: 3, keys: ['Privat oder geschäftliche Anfrage?', 'Umsatzsteuer-Identifikationsnummer', 'Interne Auftragsnummer'] },
      { t: 'Versand', step: 4, keys: ['Versand und Abholung', 'Abholdatum', 'Zeitraum', 'Wahl der Rückversandmethode'] }
    ];
    var html = '';
    // Kategorien als zugeklappte <details>-Dropdowns — voll ausgeklappt war der Step zu lang
    // (Scrollen bis zum Submit). Header zeigt Titel + Anzahl der Angaben; "ändern" liegt im
    // aufgeklappten Body, damit der Klick nicht mit dem Auf-/Zuklappen kollidiert.
    groups.forEach(function (g) {
      var filled = g.keys.filter(function (k) { return d[k]; });
      var rows = filled.map(function (k) {
        return '<div class="rf-summary-row"><b>' + k + ':</b> ' + escapeHtml(d[k]) + '</div>';
      }).join('');
      if (!rows) rows = '<div class="rf-summary-row" style="color:#9ca3af">Keine Angaben</div>';
      html += '<details class="rf-summary-group">' +
        '<summary>' +
          '<span class="rf-sum-title">' + g.t + '</span>' +
          '<span class="rf-sum-count">' + (filled.length ? filled.length + ' Angabe' + (filled.length === 1 ? '' : 'n') : '—') + '</span>' +
          '<svg class="rf-sum-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
        '</summary>' +
        '<div class="rf-summary-body">' + rows +
          '<button type="button" class="rf-edit" data-rf-goto="' + g.step + '">Angaben ändern</button>' +
        '</div></details>';
    });
    overlay.querySelector('[data-rf-summary]').innerHTML = html;
    overlay.querySelectorAll('[data-rf-goto]').forEach(function (e) {
      e.addEventListener('click', function () { goTo(+e.dataset.rfGoto); });
    });
    updateTotal();
  }

  // === LIVE-SUMME (Variante + 95€ Prüfpauschale + 10€ UPS) — nimmt die Checkout-Überraschung raus ===
  function fmtEur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function updateTotal() {
    var totalEl = overlay.querySelector('[data-rf-total]');
    if (!totalEl) return;
    var pausch = overlay.querySelector('[data-rf-pauschale]');
    var ups = overlay.querySelector('[data-rf-ups]');
    var rueck = overlay.querySelector('[name="rf_rueckweg"][value="Normalversand"]');
    var addPausch = (pausch && (RF_MK61_PRICED || pausch.checked) && !variantHidesPauschale()) ? PAUSCHALE_AMOUNT : 0;
    var addUps = (ups && ups.checked && !isAufAnfrageVariant()) ? 10 : 0; // Auf Anfrage: UPS nur Präferenz, kein Add-on
    var addRueck = (rueck && rueck.checked && !isAufAnfrageVariant() && !RF_NON_EU) ? 10 : 0; // dito: Rückversand nur bei Direktkauf bepreist
    var addons = addPausch + addUps + addRueck;
    var base = (selectedVariantCents != null) ? selectedVariantCents / 100 : 0;
    var parts = [];
    if (addPausch) parts.push(PAUSCHALE_AMOUNT + ' € Prüfpauschale');
    if (addUps) parts.push('10 € UPS-Abholung');
    if (addRueck) parts.push('10 € Rückversand');
    var note = parts.join(' + ');
    if (base > 0) {
      // Positions-Aufschlüsselung statt 'inkl. X + Y'-Prosa (Tim, 30.07.: das '+' wurde
      // als 'zzgl. auf die Summe' gelesen). Jede Zeile ist eine echte Warenkorb-Position.
      var baseLabel = (selectedVariantRawTitle && selectedVariantRawTitle !== 'Default Title')
        ? selectedVariantRawTitle : 'Reparatur';
      var rows = [[baseLabel, base]];
      if (addPausch) rows.push(['Prüfpauschale', addPausch]);
      if (addUps) rows.push(['UPS-Abholung', addUps]);
      if (addRueck) rows.push(['Rückversand', addRueck]);
      totalEl.innerHTML = rows.map(function (r) {
        return '<div class="rf-total-row"><span>' + escapeHtml(r[0]) + '</span><span>' + fmtEur(r[1]) + '</span></div>';
      }).join('') +
        '<div class="rf-total-row rf-total-sum"><span>Gesamtsumme</span><b>' + fmtEur(base + addons) + '</b></div>';
    } else {
      // "Auf Anfrage": kein fixer Reparaturpreis -> Add-ons separat ausweisen
      totalEl.innerHTML = 'Reparaturpreis: <b>auf Anfrage</b>' +
        (addons ? '<span class="rf-total-note">zzgl. ' + note + '</span>' : '');
    }
  }
  // Summe live aktualisieren, wenn Hinweg (UPS), Rückweg oder Prüfpauschale umgeschaltet wird
  overlay.querySelectorAll('[name="rf_hinweg"], [name="rf_rueckweg"], [data-rf-pauschale]').forEach(function (el) {
    el.addEventListener('change', updateTotal);
  });
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // === VARIANT ID (aktuell gewählte Reparaturart) ===
  function getVariantId() {
    if (selectedVariantId) return selectedVariantId;               // aus der geklickten Varianten-Card
    var form = document.querySelector('form[action*="/cart/add"]'); // Fallback: nativer Picker (falls noch vorhanden)
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return overlay.dataset.initialVariant;                          // letzter Fallback
  }

  // === EXKLUSIV-WARENKORB: GENAU EINE REPARATURANFRAGE, NICHTS DANEBEN ===
  // Fachregel (Tim, 2026-07-30): pro Bestellung genau EINE Reparatur und KEINE weiteren Artikel
  // (auch keine Autel-Hardware) — zwei Anfragen bzw. Misch-Bestellungen sind im Portal nicht
  // abbildbar. Reparaturzeilen erkennt `_rf_group` (setzt nur dieses Formular); alles andere im
  // Warenkorb (Hardware, Alt-Globo-Zeilen) blockiert ebenfalls. Die Gegenrichtung — Hardware
  // NACH der Anfrage in den Warenkorb legen — kann dieses Formular nicht verhindern; dafuer
  // braucht es ein Gate am Kauf-Pfad bzw. an der Kasse.
  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function mk61ValidChoice() {
    if (!mk61ChoiceMade) return false;
    return Array.prototype.some.call(document.querySelectorAll('[data-rf-variant]'), function (card) {
      return String(card.dataset.rfVariant) === String(selectedVariantId) && card.dataset.rfVariantRawtitle === selectedVariantRawTitle && Number(card.dataset.rfVariantCents) === Number(selectedVariantCents);
    });
  }
  function mk20ProtectedNumber() {
    if (!RF_MK20_PRICED || !(Number(selectedVariantCents) > 0)) return false;
    var protectedHandles;
    try { protectedHandles = JSON.parse(overlay.dataset.rfMk20Protected || '[]'); } catch (e) { return true; }
    if (!Array.isArray(protectedHandles)) return true;
    var input = overlay.querySelector('[data-prop="Teilenummer(n)"]');
    var prefixes = ['ate','bosch','continental','conti','siemens','vdo','temic','valeo','delphi','denso','hella','trw','wabco','zf','luk','sachs','magneti','marelli','aisin','getrag','mando','nissin','oe','oem','teilenummer','partno','part','nr','no','pn'];
    function normalized(value) { return value.toLowerCase().replace(/[^a-z0-9]/g, ''); }
    return String(input ? input.value : '').split(/[,;\n]+|\s+[\/|]\s+/).some(function (entry) {
      var words = entry.split(/\s+/).filter(function (word) { return normalized(word).length > 0; });
      while (words.length && prefixes.indexOf(normalized(words[0])) >= 0) words.shift();
      return protectedHandles.indexOf(normalized(words.join(' '))) >= 0;
    });
  }
  function cartBlockReason() {
    if (RF_MK61_PRICED || RF_MK20_PRICED) {
      if (!window.RFMk61Cart) return Promise.resolve('unavailable');
      return window.RFMk61Cart.read(fetch, shopRoot()).then(function (cart) { if (!cart.items.length) return null; return cart.items.some(function (it) { var p = it.properties || {}; return p._rf_group && !p._rf_addon; }) ? 'repair' : 'other'; }).catch(function () { return 'unavailable'; });
    }
    return fetch(shopRoot() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var repairs = items.filter(function (it) {
          var p = it.properties || {};
          return p._rf_group && !p._rf_addon;
        }).length;
        if (repairs > 0) return 'repair';
        if (items.length > 0) return 'other';
        return null;
      })
      .catch(function () { return null; }); // Warenkorb nicht lesbar -> nicht blockieren, lieber durchlassen
  }

  // Ein fehlgeschlagener Cart-Call darf NICHT stillschweigend durchlaufen (#3): bei 422
  // (Variante nicht kaufbar), 413 (Upload zu gross) oder einer Bot-Challenge kam vorher
  // HTML/JSON-Fehler zurueck, die Kette lief weiter bis /checkout — der Kunde zahlte ohne
  // Pruefpauschale, die Order kam mit widerspruechlichen Properties an.
  function cartFetch(url, init, label) {
    if (RF_MK61_PRICED) url = shopRoot() + url.replace(/^\//, '');
    return fetch(url, init).then(function (res) {
      if (res.ok) return res.json().catch(function () { return null; });
      return res.text().then(function (body) {
        var msg = '';
        try { msg = (JSON.parse(body) || {}).description || ''; } catch (e) {}
        throw { description: msg || ('Der Warenkorb hat die Position "' + label + '" abgelehnt (HTTP ' + res.status + ').') };
      });
    });
  }

  // Exklusiv-Warenkorb-Hinweis beim ÖFFNEN: belegter Warenkorb -> Panel statt Formular,
  // damit niemand 5 Schritte umsonst ausfüllt. Der Submit-Check unten bleibt als Backstop
  // (der Warenkorb kann sich ändern, während das Popup offen ist). Async: das Panel erscheint
  // wenige 100ms nach dem Öffnen — bei leerem Warenkorb (Normalfall) passiert nichts.
  function refreshCartGuard() {
    var guard = overlay.querySelector('[data-rf-cart-guard]');
    var msg = overlay.querySelector('[data-rf-cart-guard-msg]');
    if (!guard || !msg) return;
    cartBlockReason().then(function (reason) {
      if (!overlay.classList.contains('is-open')) return; // inzwischen geschlossen
      if (reason) {
        msg.innerHTML = reason === 'unavailable' ? 'Ihr Warenkorb konnte nicht geprüft werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.' : reason === 'repair'
          ? 'Sie haben bereits eine Reparaturanfrage im <a href="' + shopRoot() + 'cart">Warenkorb</a>. ' +
            'Pro Bestellung ist eine Anfrage möglich — bitte schließen Sie diese zuerst ab oder entfernen Sie sie.'
          : 'Ihr <a href="' + shopRoot() + 'cart">Warenkorb</a> enthält bereits andere Artikel. ' +
            'Eine Reparaturanfrage muss separat bestellt werden — bitte schließen Sie den Kauf zuerst ab oder leeren Sie den Warenkorb.';
        guard.classList.remove('rf-hidden');
        overlay.classList.add('rf-guard-active');
        rfTrack('repair_funnel_cart_guard_shown', { reason: reason });
      } else {
        guard.classList.add('rf-hidden');
        overlay.classList.remove('rf-guard-active');
      }
    });
  }

  // Bosch5.7: only documented numbers belonging to this exact product may enter paid booking.
  function bosch57UnassignedNumber() {
    if (overlay.dataset.rfBosch57Priced !== '1') return false;
    var input = overlay.querySelector('[data-prop="Teilenummer(n)"]');
    var allowed = (overlay.dataset.rfBosch57Parts || '').split('|').filter(Boolean);
    var numbers = String(input ? input.value : '').split(/[;\n,/]+/).map(function (v) { return v.toLowerCase().replace(/[^a-z0-9]/g, ''); }).filter(Boolean);
    return numbers.length === 0 || numbers.some(function (number) { return allowed.indexOf(number) < 0; });
  }

  // === SUBMIT -> /cart/add.js ===
  submitBtn.addEventListener('click', function () {
    if (bosch57UnassignedNumber()) { submitError.textContent = 'Bitte klären Sie diese Teilenummer vor einer kostenpflichtigen Buchung. Mehrere vollständige Nummern bitte mit Komma trennen.'; submitError.style.display = 'block'; return; }
    if ((RF_MK61_PRICED || RF_MK20_PRICED) && mk61Submitting) return;
    if (RF_MK20_PRICED && (!mk61ValidChoice() || !(selectedVariantRawTitle === 'Reparatur' && Number(selectedVariantCents) === 23900))) { submitError.textContent = 'Bitte wählen Sie die Variante Reparatur für 239 €.'; submitError.style.display = 'block'; return; }
    if (RF_MK61_PRICED && (!window.RFMk61Cart || !mk61ValidChoice() || PAUSCHALE_VARIANT_ID !== 55744436404606 || PAUSCHALE_AMOUNT !== 60 || (RF_MK20_PRICED ? ['Reparatur'] : ['Reparatur Hydraulik','Reparatur Pumpenmotor','Reparatur Steuergerät','Generalüberholung']).indexOf(selectedVariantRawTitle) < 0 || !(selectedVariantCents > 0))) {
      submitError.textContent = 'Bitte laden Sie die Seite neu und wählen Sie eine Reparaturart aus.'; submitError.style.display = 'block'; return;
    }
    if (mk20ProtectedNumber()) { submitError.textContent = 'Die Geräteausführung zu dieser Kennzeichnung muss zuerst geprüft werden. Bitte klären Sie die Gerätezuordnung vor einer kostenpflichtigen Beauftragung.'; submitError.style.display = 'block'; return; }
    // ALLE Schritte validieren, nicht nur die Zusammenfassung (#5). Nach einem Reload stellt
    // restoreState() zwar Werte wieder her, aber Datei-Uploads lassen sich nicht wiederherstellen
    // und der Upload-Modus ist Default — die Anfrage ging sonst ohne Fahrzeugschein UND ohne
    // manuelle Fahrzeugdaten raus, weil deren Pflichtfelder im versteckten Block liegen.
    for (var st = 1; st <= TOTAL_STEPS; st++) {
      if (!validateStep(st)) {
        goTo(st);
        focusFirstError(st);
        submitError.textContent = 'Bitte vervollständigen Sie Schritt ' + st + '.';
        submitError.style.display = 'block';
        return;
      }
    }
    if (RF_MK61_PRICED || RF_MK20_PRICED) mk61Submitting = true;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Wird hinzugefügt …';
    submitError.style.display = 'none';

    cartBlockReason().then(function (reason) {
      if (reason) {
        mk61Submitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = rfSubmitLabel();
        submitError.innerHTML = reason === 'unavailable' ? 'Ihr Warenkorb konnte nicht geprüft werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.' : reason === 'repair'
          ? 'Sie haben bereits eine Reparaturanfrage im Warenkorb. ' +
            'Pro Bestellung ist eine Anfrage möglich — bitte schließen Sie diese zuerst ab oder ' +
            'entfernen Sie sie im <a href="' + shopRoot() + 'cart">Warenkorb</a>.'
          : 'Ihr <a href="' + shopRoot() + 'cart">Warenkorb</a> enthält bereits andere Artikel. ' +
            'Eine Reparaturanfrage muss separat bestellt werden — bitte schließen Sie den Kauf ' +
            'zuerst ab oder leeren Sie den Warenkorb.';
        submitError.style.display = 'block';
        return;
      }
      doSubmit();
    });
  });

  function doSubmit() {
    var fd = new FormData();
    fd.append('id', getVariantId());
    fd.append('quantity', 1);
    // Gruppen-ID für die Add-on-Verknüpfung (Hauptitem trägt _rf_group, Add-ons _rf_parent == _rf_group)
    var rfGroup = RF_MK61_PRICED ? window.RFMk61Cart.createGroup() : 'rf' + (new Date()).getTime();
    if (RF_MK61_PRICED) fd.append('properties[_rf_contract]', 'mk61-v1');
    var mk61Expected = RF_MK61_PRICED ? { group: rfGroup, variantId: fd.get('id'), priceCents: selectedVariantCents, requireUps: !!(overlay.querySelector('[data-rf-ups]:checked') && !RF_NON_EU), requireReturn: !!(overlay.querySelector('[name="rf_rueckweg"][value="Normalversand"]:checked') && !RF_NON_EU) } : null;
    fd.append('properties[_rf_group]', rfGroup);
    // Felder als properties[…]
    overlay.querySelectorAll('[data-prop]').forEach(function (el) {
      var key = 'properties[' + el.dataset.prop + ']';
      if (el.closest('.rf-hidden')) return; // versteckte Conditional-Felder nie senden (wie collectFields)
      if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) fd.append(key, el.value); }
      else if (el.type === 'file') {
        if (!el.files || !el.files.length) return;
        // Mehrere Dateien -> indizierte Keys "Anhänge-1…N" (so mappt Mechanic Multi-Uploads);
        // einzelne Datei bleibt unter dem Plain-Key.
        if (el.files.length > 1) {
          for (var fi = 0; fi < el.files.length; fi++) {
            fd.append('properties[' + el.dataset.prop + '-' + (fi + 1) + ']', el.files[fi]);
          }
        } else {
          fd.append(key, el.files[0]);
        }
      }
      else if (el.value && el.value.trim()) {
        var v = el.value.trim();
        // Teilenummer(n) ist eine TEXTAREA, das Ziel-Metafeld aber single_line_text_field:
        // ein Zeilenumbruch liess Mechanics atomaren metafieldsSet-Batch komplett scheitern
        // (Order verlor ALLE 14 Metafelder — Vorfall #6783/#6784, 2026-07-30).
        if (el.dataset.prop === 'Teilenummer(n)') v = v.replace(/\s*\r?\n+\s*/g, ', ');
        fd.append(key, v);
      }
    });

    fetch(RF_MK61_PRICED ? shopRoot() + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { if (!res.ok) return res.json().then(function (e) { throw e; }); return res.json(); })
      .then(function () {
        // Bei "Auf Anfrage" KEINE bepreiste UPS-Position: die Wahl ist nur Präferenz (Property),
        // gebucht + berechnet wird auf der Angebots-Landingpage (sonst Doppelberechnung im KV,
        // da detectQuotedMethod das Line-Item als gebuchten Hinweg lesen würde).
        var ups = overlay.querySelector('[data-rf-ups]');
        if (ups && ups.checked && !isAufAnfrageVariant() && !RF_NON_EU && UPS_VARIANT_ID) {
          return cartFetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: UPS_VARIANT_ID, quantity: 1, properties: { _rf_addon: 'ups', _rf_parent: rfGroup, _rf_contract: RF_MK61_PRICED ? 'mk61-v1' : undefined } })
          }, 'UPS-Abholung');
        }
      })
      .then(function () {
        // Rückversand (Normalversand, +10€) bei DIREKTKAUF als bepreiste Position — sonst wählt der
        // Kunde "zzgl. 10 € Brutto", zahlt sie aber nie. Bei "Auf Anfrage" nur Property (KV bepreist).
        var rueck = overlay.querySelector('[name="rf_rueckweg"][value="Normalversand"]');
        if (rueck && rueck.checked && !isAufAnfrageVariant() && !RF_NON_EU && RUECKVERSAND_VARIANT_ID) {
          return cartFetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: RUECKVERSAND_VARIANT_ID, quantity: 1, properties: { _rf_addon: 'rueckversand', _rf_parent: rfGroup, _rf_contract: RF_MK61_PRICED ? 'mk61-v1' : undefined } })
          }, 'Rückversand');
        }
      })
      .then(function () {
        // Prüfpauschale als separate, bepreiste Position hinzufügen, wenn die Checkbox angehakt ist.
        // Preis kommt aus der Variante (PAUSCHALE_VARIANT_ID) -> der Cart-Subtotal steigt sichtbar.
        // Varianten-Gate zusätzlich zur (bei Hide entfernten) Checkbox — doppelte Sicherung.
        var pausch = overlay.querySelector('[data-rf-pauschale]');
        if (pausch && pausch.checked && !variantHidesPauschale() && PAUSCHALE_VARIANT_ID) {
          return cartFetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: PAUSCHALE_VARIANT_ID, quantity: 1, properties: { _rf_addon: 'pruefpauschale', _rf_parent: rfGroup, _rf_contract: RF_MK61_PRICED ? 'mk61-v1' : undefined } })
          }, 'Prüfpauschale');
        }
      })
      .then(function () {
        if (!RF_MK61_PRICED) return;
        return window.RFMk61Cart.read(fetch, shopRoot()).then(function (cart) {
          var state = window.RFMk61Cart.inspect(cart, mk61Expected);
          if (!state.valid) throw { description: 'Reparatur und Prüfpauschale konnten nicht gemeinsam bestätigt werden. Bitte versuchen Sie es erneut.' };
        });
      })
      .then(function () {
        // Flag setzen: Anfrage komplett -> Cart-Funnel (Variante B) wird übersprungen
        return cartFetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: { _anfrage: 'komplett' } })
        }, 'Anfrage-Kennzeichen');
      })
      .then(function () {
        rfSubmitting = true;
        var pausch = overlay.querySelector('[data-rf-pauschale]');
        var ups = overlay.querySelector('[data-rf-ups]');
        var rueck = overlay.querySelector('[name="rf_rueckweg"][value="Normalversand"]');
        rfTrack('repair_funnel_submitted', {
          pauschale: !!(pausch && pausch.checked && !variantHidesPauschale()),
          ups_pickup: !!(ups && ups.checked && !isAufAnfrageVariant() && !RF_NON_EU),
          rueckversand: !!(rueck && rueck.checked && !isAufAnfrageVariant() && !RF_NON_EU),
          is_auf_anfrage: isAufAnfrageVariant()
        }, { transport: 'sendBeacon' });
        clearState(); window.location.href = '/checkout';
      })
      .catch(function (err) {
        function showError(cleaned) {
          mk61Submitting = false;
          submitBtn.disabled = false;
          submitBtn.textContent = rfSubmitLabel();
          submitError.textContent = (err && err.description) ? err.description : 'Es ist ein Fehler aufgetreten. Bitte erneut versuchen.';
          if (RF_MK61_PRICED && !cleaned) {
            submitError.appendChild(document.createTextNode(' Bitte entfernen Sie den unvollständigen Auftrag im '));
            var link = document.createElement('a'); link.href = shopRoot() + 'cart'; link.textContent = 'Warenkorb'; submitError.appendChild(link);
            submitError.appendChild(document.createTextNode(' und legen Sie ihn erneut an.'));
          }
          submitError.style.display = 'block';
          rfTrack('repair_funnel_submit_failed', { message: String((err && err.description) || err || 'unbekannt').slice(0, 200) });
        }
        if (RF_MK61_PRICED) window.RFMk61Cart.rollback(fetch, shopRoot(), rfGroup).then(showError);
        else showError(true);
      });
  }

  // === SESSION-PERSISTENZ — übersteht versehentlichen Reload (sessionStorage: pro Tab, beim Tab-Schließen weg) ===
  // Hinweis: Datei-Uploads (Fahrzeugschein/Anhänge) lassen sich NICHT wiederherstellen (Browser-Security) → nach Reload neu anhängen.
  var STORAGE_KEY = 'rf_funnel_' + (overlay.dataset.rfKey || overlay.dataset.initialVariant || 'default');
  function saveState() {
    try {
      var data = { step: current, fields: {}, radios: {}, checks: {} };
      overlay.querySelectorAll('[data-prop]').forEach(function (el) {
        if (el.type === 'file') return;
        if (el.type === 'radio') { if (el.checked) data.radios[el.name] = el.value; }
        else if (el.type === 'checkbox') { data.checks[el.dataset.prop] = el.checked; }
        else { data.fields[el.dataset.prop] = el.value; }
      });
      var vm = overlay.querySelector('[name="rf_vehicle_mode"]:checked');
      if (vm) data.radios['rf_vehicle_mode'] = vm.value;
      data.variant = { mk61Chosen: (RF_MK61_PRICED || RF_MK20_PRICED) ? mk61ChoiceMade : undefined, id: selectedVariantId, title: selectedVariantTitle, price: selectedVariantPrice, cents: selectedVariantCents, raw: selectedVariantRawTitle };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* sessionStorage nicht verfügbar -> still ignorieren */ }
  }
  function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      // Gewählte Reparaturart wiederherstellen (übersteht Reload mitten im Flow)
      if (data.variant && data.variant.id) {
        if (RF_MK61_PRICED || RF_MK20_PRICED) mk61ChoiceMade = data.variant.mk61Chosen === true;
        selectedVariantId = data.variant.id;
        selectedVariantTitle = data.variant.title || null;
        selectedVariantPrice = data.variant.price || null;
        selectedVariantCents = (data.variant.cents != null) ? data.variant.cents : null;
        selectedVariantRawTitle = data.variant.raw || data.variant.title || null;
        if (RF_MK20_PRICED) {
          RF_MK61_PRICED = RF_MK61_BASE_PRICED || Number(selectedVariantCents) > 0;
          if (!mk61ValidChoice()) { mk61ChoiceMade = false; selectedVariantId = null; selectedVariantTitle = null; selectedVariantPrice = null; selectedVariantCents = null; selectedVariantRawTitle = null; RF_MK61_PRICED = RF_MK61_BASE_PRICED; }
        }
        reflectVariant(selectedVariantTitle, selectedVariantPrice);
      }
      overlay.querySelectorAll('[data-prop]').forEach(function (el) {
        if (el.type === 'file' || el.type === 'radio' || el.type === 'checkbox') return;
        if (data.fields && data.fields[el.dataset.prop] != null) el.value = data.fields[el.dataset.prop];
      });
      overlay.querySelectorAll('input[type="checkbox"][data-prop]').forEach(function (el) {
        if (data.checks && typeof data.checks[el.dataset.prop] === 'boolean') el.checked = data.checks[el.dataset.prop];
      });
      if (data.radios) {
        Object.keys(data.radios).forEach(function (name) {
          overlay.querySelectorAll('[name="' + name + '"]').forEach(function (r) {
            if (r.value === data.radios[name]) r.checked = true;
          });
        });
      }
      // Conditional-Logik nachziehen (Manuell/Upload, Privat/Geschäftlich, Fehlercode-Texte) — programmatic .checked feuert kein 'change'
      ['rf_vehicle_mode', 'rf_kundentyp', 'rf_hinweg', 'rf_fehlercodes'].forEach(function (name) {
        var c = overlay.querySelector('[name="' + name + '"]:checked');
        if (c) c.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // NACH der Checkbox-Wiederherstellung: Varianten-Regeln anwenden (entcheckt ggf. eine
      // wiederhergestellte Pauschale-Checkbox, wenn die Variante sie versteckt) + Trust-Text/Total
      applyVariantRules();
      return data;
    } catch (e) { return null; }
  }
  function clearState() { try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  overlay.addEventListener('input', saveState);
  overlay.addEventListener('change', saveState);

  // Beim Laden wiederherstellen; war man mitten im Flow (Step > 1), Funnel automatisch dort wieder öffnen
  var _restored = restoreState();
  if (_restored && _restored.step > 1) { open(_restored.step); }
})();
